/* Dependencies */
import Siema from 'siema';

/**
 * ProducerCarousel
 * @class
 */
 class ProducerCarousel {
  public containerElement: HTMLElement;
  public sliderElement: HTMLElement;
  public totalSlides: number;
  public dotsElement: HTMLElement[];
  public prevElement: HTMLElement;
  public nextElement: HTMLElement;
  
  public carousel: Siema;

  constructor(container: HTMLElement) {
    this.containerElement = container;
    this.sliderElement = this.containerElement.querySelector('[data-slider]');
    this.totalSlides = this.sliderElement.childElementCount;
    this.dotsElement = Array.from(this.containerElement.querySelectorAll('.slider__dots > *'));
    this.prevElement = this.containerElement.querySelector('.slider__prev.active');
    this.nextElement = this.containerElement.querySelector('.slider__next.active');

    if(this.totalSlides < 2) return;

    // Create a carousel instance.
    this.carousel = new Siema({
      selector: this.sliderElement,
      duration: 350,
      easing: 'ease-out',
      perPage: 1,
      loop: true,
      onInit() {
        // allows center mode
        this.selector.style.overflow = 'initial'
      },
      onChange: () => {
        // update dots with main slider
        const dots = this.dotsElement[this.carousel.currentSlide] as HTMLElement;
        dots.click();  
        this.toogleButtons();  
      },
    });

    this.setDots();
    this.setButtons();

  }

  /**
   * Initialize Dots
   */
  setDots(): void {
    // Ensure element exist.
    if (!this.dotsElement) return;
    
    let prevActive = 0;
    // Loop the dots and attach click event.
    this.dotsElement.forEach((currentdots, index) => {
      // Add the initial active class.
      if (index === 0) {
        currentdots.classList.add('active');
      }
  
      // Bind click event.
      currentdots.addEventListener('click', () => {
        // Go to slide.
        this.carousel.goTo(index);
        // Update active dots.
        this.dotsElement[prevActive].classList.remove('active');
        this.dotsElement[index].classList.add('active');
        // Update state
        prevActive = index;
      });
    });
  }

  /**
  * Bind event Prev/Next Buttons
  */
  setButtons(): void {
    // Check if buttons exist and activated
    this.toogleButtons();

    // event handlers on buttons prev & next
    this.prevElement.addEventListener('click', () => this.carousel.prev());
    this.nextElement.addEventListener('click', () => this.carousel.next());
  }

  /**
  * Toogle Buttons
  */
  toogleButtons(): void {
    // Ensure element exist.
    if (!this.prevElement) return;
    if (!this.nextElement) return;

    // Ensure not activated.
    this.prevElement.classList.remove('active');
    this.prevElement.setAttribute('aria-disabled', 'true');
    this.nextElement.classList.remove('active');
    this.nextElement.setAttribute('aria-disabled', 'true');

    if(this.carousel.currentSlide > 0) {
      this.prevElement.classList.add('active');
      this.prevElement.setAttribute('aria-disabled', 'false');
    }
    if(this.carousel.currentSlide < this.totalSlides-1) {
      this.nextElement.classList.add('active');
      this.nextElement.setAttribute('aria-disabled', 'false');
    }
  }
}

/**
 * Initiates the producer carousel.
 * @returns
 */
export const producerCarouselInit = (): void => {

  // Retrieve the slider elements.
  const sliderElements = Array.from(
    document.querySelectorAll('[data-slider-container]')
  );

  //  If no slider elements, return.
  if (!sliderElements.length) return;

   // Loop and create section instances.
   sliderElements.forEach((sliderElement) => {
    // Create ProducerCarousel.
    new ProducerCarousel(sliderElement as HTMLElement);
  });
};
